// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BlogsShortMessageDetail__complaint":"kc_a bia_sb"};